import React from 'react';
import PropTypes from 'prop-types';
import { Route, Switch } from 'react-router-dom';
import { Grid, Row, Col } from 'react-bootstrap';

import OrderForm from '../order/form';

import CategoriesPage from './categories';
import ThankYou from './thankYou';
import PilotSchools from './PilotSchools';

export default class Order extends React.Component {
  static propTypes = {
    match: PropTypes.shape({
      url: PropTypes.string.isRequired
    }).isRequired
  };

  render() {
    const { match } = this.props;

    return (
      <Grid>
        <Row>
          <Col md={10} mdOffset={1}>
            <Switch>
              <Route path={`${match.url}/workshopy`} component={CategoriesPage} />
              <Route exact path={`${match.url}/udaje`} component={OrderForm} />
              <Route exact path={`${match.url}/dekujeme`} component={ThankYou} />
              <Route exact path={`${match.url}/pilotni-skoly`} component={PilotSchools} />
            </Switch>
          </Col>
        </Row>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/Feature/order/index.jsx